


const CustomScheduleFormHeader = ({ title }: { title: string }) => {
    return (
        <div className={`custom__schedule__modal__form__header`}>
            <span className="custom__schedule__modal__form__header__title">{title}</span>
        </div>
    )
}

export default CustomScheduleFormHeader